<template>
  <div class="use-content">
    <div class="title"><i></i>使用必读</div>
    <div class="use-list">
      <div class="use-item" v-for="item in list" :key="item.id">
        <div class="title" @click="handleJump(item.id)">
          {{ item.title }}
        </div>
        <!-- item.previews.slice(0, 5) -->
        <ul>
          <li
            v-for="(el, index) in item.previews" :key="index"
            @click="handleJump(item.id, el.id)">
            {{ el.title }}
          </li>
        </ul>
        <div class="query-all" v-if="item.previews.length > 4" @click="handleJump(item.id)">查看更多></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTutorialOverview } from '@/api/course.js'
import { setItem } from '@/utils/storage.js'
export default {
  name: 'useList', // 使用必读
  components: {},
  props: {},
  data() {
    return {
      list: [],
    }
  },
  computed: {},
  watch: {},
  created() { 
    this.getTutorialOverview()
  },
  mounted() {
  },
  methods: {
    async getTutorialOverview() {
      let res = await getTutorialOverview()
      if (res.success) {
        this.list = res.data
      }
      /* const { params: { type } } = this.$route
      if (type === 'courseVideo') this.rollVideos() */
    },
    handleJump(courseId, id) {
      const newPage = this.$router.resolve({ 
        name: 'courseDetail', 
        query: { id: courseId },
      })
      window.open(newPage.href, '_blank')
      setItem('askId', id + '')
    },
  }
}
</script>

<style scoped lang="scss">
.use-content {
  margin-bottom: 180px;
  .title {
    i {
      display: inline-block;
      width: 22px;
      height: 22px;
      background: url('../../../assets/use-course/course-svg.svg') no-repeat;
      background-size: 100%;
      vertical-align: middle;
      margin-right: 8px;
    }
    font-size: 20px;
    font-weight: bold;
    color: #232835;
    margin-bottom: 28px;
  }
  .use-list {
    display: flex;
    justify-content: space-between;
    .use-item {
      position: relative;
      width: 380px;
      height: 500px; /* 356px */
      overflow-y: auto;
      padding: 30px 24px;
      box-shadow: 0px 2px 10px 0px rgba(255, 255, 255, 0.1),
        0px 6px 26px 0px rgba(95, 139, 230, 0.16);
      border-radius: 8px;
      color: #24232f;
      background: rgba(255, 255, 255, 0.4);
      .title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 16px;
        cursor: pointer;
      }
      ul {
        padding-left: 20px;
        font-size: 14px;
        font-weight: 400;
        line-height: 38px;
        height: 340px;
        overflow: hidden;
        li {
          cursor: pointer;
        }
        li:hover {
          color: #3c7cff;
        }
        .line {
          line-height: 28px;
          margin-bottom: 6px;
        }
      }
      .query-all {
        position: absolute;
        bottom: 30px;
        left: 50%;
        transform: translate(-50%, 0);
        font-size: 14px;
        font-weight: 400;
        color: #3c7cff;
        cursor: pointer;
      }
    }
  }
}
</style>
